import { Grid } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import React, { PropsWithChildren, useCallback } from 'react'
import { Select } from './../form/Select'
import {
  StyledTopicFilterOption,
  StyledTopicFilterOptionWrapper,
  StyledTopicFilterRow,
  StyledTopicFilterTitle,
} from './Styled'

export type TopicFiltersProps = {
  multiple?: boolean
  filterTitle?: string
  selectedFilters?: string[]
  filterOptions: Array<{ value: string; text: string }>
  onChangeEvent?: (values: string[]) => void
  loading?: boolean
} & React.ComponentProps<typeof StyledTopicFilterOptionWrapper>

export const TopicFilters: React.FC<PropsWithChildren<TopicFiltersProps>> = ({ multiple, filterTitle, selectedFilters = [], filterOptions, onChangeEvent, loading, ...props }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  // On change in dropdown list
  const handleInputChange = useCallback(e => {
    if (onChangeEvent) {
      onChangeEvent([e.target.value])
    }
  }, [onChangeEvent])

  // On click item
  const handleClickItem = useCallback((value) => {
    if (!onChangeEvent) {
      return null
    }

    if (multiple) {
      if (selectedFilters.includes(value)) {
        onChangeEvent(selectedFilters.filter(x => x !== value))
      } else {
        onChangeEvent([...selectedFilters, value])
      }
    } else {
      if (!selectedFilters.includes(value)) {
        onChangeEvent([value])
      }
    }
  }, [multiple, onChangeEvent, selectedFilters])

  if (isMobile) {
    return (
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <StyledTopicFilterTitle variant="h5" $loading={loading}>
            {filterTitle}
          </StyledTopicFilterTitle>
          <Select
            {...props}
            onChange={handleInputChange}
            name="topicFilters"
            value={selectedFilters}
            options={filterOptions}
            multiple={multiple}
            fullWidth
            MenuProps={{
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
            }}>
          </Select>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container>
      <Grid item sm={12} justifyContent="center" alignItems="center" id="filter">
        <StyledTopicFilterTitle variant="h5" tabIndex={0} $loading={loading} className="topic-filter-title">
          {filterTitle}
        </StyledTopicFilterTitle>
      </Grid>
      <StyledTopicFilterRow container item sm={12} justifyContent="center" alignItems="center"> {
        filterOptions.map((item, index) => {
          return (
            <StyledTopicFilterOptionWrapper
              key={index}
              className={selectedFilters.includes(item.value) ? 'active' : ''}
              onClick={() => handleClickItem(item.value)}>
              <StyledTopicFilterOption>{item.text}</StyledTopicFilterOption>
            </StyledTopicFilterOptionWrapper>
          )
        })
      }
      </StyledTopicFilterRow>
    </Grid>
  )
}
